export default "__VITE_ASSET__CPUGKFj8__"